module.exports = __webpack_public_path__ + "static/media/o16.46c6ede7.png";